import React from 'react'
import './player-list-desktop.styles.scss';

import xp_icon from '@/assets/icons/xp.png';
import coin_icon from '@/assets/icons/coin.png';
import coins_icon from '@/assets/icons/coins.png';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { formatNumber } from '@/utils/formatNumber';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PlayerListDesktop = ({
  gameData,
  sortedPlayers,
  setCurrentSort,
  chooseInfo,
  manager,
  gameElements,
  viewHeight
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const navigate = useNavigate();

  return (
    <div className={`player-list-desktop ${screenSize}`}>

      <div className='chart-row '>
        {/* <div className='chart-row'> */}
        <div className='number-div'>#</div>
        <button 
          className='g-button text-only name-div' 
          onClick={() => setCurrentSort(null)}>
          Name
        </button>
        
        <div className='info-div' >
          <button 
            className='g-button text-only name-div' 
            onClick={() => setCurrentSort('playerInfo')}>
            Player Info
          </button>
        </div>
        
        <div className='info-div'>
          <button
            className='g-button text-only name-div' 
            onClick={() => setCurrentSort('alias')}>
            Alias
          </button>
        </div>
        {
          (gameData.access.includes('points')) &&
          <button 
            className='g-button text-only chart-button' 
            onClick={() => setCurrentSort('points')} 
            title='Total XP'>
            <img 
              src={xp_icon} 
              className='icon' />
          </button>
        }
        
        {
          (gameData.access.includes('levels')) &&
          <button 
            className='g-button text-only chart-button' 
            onClick={() => setCurrentSort('points')} 
            title='Level'>
            <ImageContainer 
              src='/images/icons/levels3.png' 
              className='icon' 
              alt='levels icon' />
          </button>
        }
        {
          (gameData.access.includes('currency')) &&
          <button 
            className='g-button text-only chart-button' 
            onClick={() => setCurrentSort('currencyTotal')} 
            title='Total Currency Earned'>
            <img 
              src={coins_icon} 
              className='icon' />
          </button>
        }
        {
          (gameData.access.includes('currency')) &&
          <button 
            className='g-button text-only chart-button' 
            onClick={() => setCurrentSort('currency')} 
            title='Current Currency Balance'>
            <img 
              src={coin_icon} 
              className='icon' />
          </button>
        }
        {/* {
          (manager && gameData.access.includes('badges')) &&
          <button 
            className='g-button text-only chart-button' 
            onClick={() => setCurrentSort('badges')} 
            title='Badges'>
            <ImageContainer 
              src='/images/icons/badges.png' 
              className='icon' 
              alt='badges icon' />
          </button>
        }
        {
          (manager && gameData.access.includes('items')) &&
          <button 
            className='g-button text-only chart-button' 
            onClick={() => setCurrentSort('items')} 
            title='Items'>
            <ImageContainer 
              src='/images/icons/items.png' 
              className='icon' 
              alt='items icon' />
          </button>
        }
        {
          (manager && gameData.access.includes('secretCodes')) &&
          <button 
            className='g-button text-only chart-button' 
            onClick={() => setCurrentSort('codes')} 
            title='Codes Found'>
            <ImageContainer 
              src='/images/icons/secret2.png' 
              className='icon' 
              alt='secret codes icon' />
          </button>
        }
        {
          (manager && gameData.access.includes('challenges')) &&
          <button 
            className='g-button text-only chart-button' 
            onClick={() => setCurrentSort('challenges')} 
            title='Challenges Completed'>
            <ImageContainer 
              src='/images/icons/challenge.png' 
              className='icon' 
              alt='challenges icon' />
          </button>
        }
        {
          (manager && gameData.access.includes('quests')) &&
          <button 
            className='g-button text-only chart-button' 
            onClick={() => setCurrentSort('quests')} 
            title='Quests Completed'>
            <ImageContainer 
              src='/images/icons/quests.png' 
              className='icon' 
              alt='quests icon' />
          </button>
        } */}
      </div>
      <div className='chart-bottom-grid' style={{ 'height': viewHeight }}>
        {
          (
            sortedPlayers.length > 0
          ) &&
          sortedPlayers.map((player, index) => {
            let playerLevel;
            if (player.levels && gameElements) {
              const lastLevel = Object.values(player.levels)
              .sort((a, b) => a.ts < b.ts ? 1 : -1)[0]
              playerLevel = gameElements[lastLevel.id];
            } else if (gameElements) {
              const levels = Object.values(gameElements)
                .filter(e => e.type === 'level' && e.status === 'active')
                .sort((a, b) => a.opt_pointMinimum > b.opt_pointMinimum ? 1 : -1)
              for (let l of levels) {
                if (player.points >= l.opt_pointMinimum) {
                  playerLevel = l;
                }
              }
            }
            return (
              <div 
                key={player.playerId} 
                className='chart-row' 
                id={`name-row-${player.playerId}`}>
                <div className='number-div'>
                  {index + 1}
                </div>
                <button
                  className='g-button text-only name-div'
                  onClick={() => navigate(player.path)}
                >
                  {
                    `${player.lName
                      ?
                      `${player.lName}, `
                      :
                      ''
                    }${player.fName}`
                  }
                </button>
                {
                  (player.info)
                  ?
                  <button
                      className='g-button text-only name-div'
                      onClick={() => chooseInfo(player.info)}
                    >
                      <span className='meta'>
                        {player.info}
                      </span>
                  </button>
                  :
                  <div className='name-div meta'></div>
                }
                <div
                  className='name-div meta'>
                  {player.alias ? player.alias : 'No Alias'}
                </div>

                {
                  (gameData.access.includes('points')) &&
                  <button className='g-button text-only chart-button' onClick={() => navigate(`${player.path}/xp`)}>
                    {player.points ? formatNumber(player.points) : '0'}
                  </button>
                }
                {
                  (gameData.access.includes('levels')) &&
                  <button
                    className='g-button text-only chart-button'
                    title={playerLevel ? playerLevel.name : ''}
                    onClick={() => navigate(`${player.path}/levels`)}
                  >
                    {
                      playerLevel ?
                        <ImageContainer
                          src={playerLevel.icon}
                          className='level-icon'
                        /> :
                        <span className='no-level'>No level</span>
                    }
                  </button>
                }
                {
                  (gameData.access.includes('currency')) &&
                  <button className='g-button text-only chart-button' onClick={() => navigate(`${player.path}/currency`)}>
                    {player.currencyTotal ? formatNumber(player.currencyTotal) : '0'}
                  </button>
                }
                {
                  (gameData.access.includes('currency')) &&
                  <button className='g-button text-only chart-button' onClick={() => navigate(`${player.path}/currency`)}>
                    {player.currency ? formatNumber(player.currency) : '0'}
                  </button>
                }
                {/* {
                  (manager && gameData.access.includes('badges')) &&
                  <button className='g-button text-only chart-button' onClick={() => navigate(`${player.path}/badges`)}>
                    {player.badges ? Object.keys(player.badges).length : '0'}
                  </button>
                }
                {
                  (manager && gameData.access.includes('items')) &&
                  <button
                    className='g-button text-only chart-button'
                    onClick={() => navigate(`${player.path}/inventory`)}>
                    {
                      (
                        gameElements &&
                        player.items
                      )
                        ?
                        Object.values(player.items)
                          // .filter(i => 
                          //     gameElements[i.id].opt_itemType !== 'lottery' &&
                          //     gameElements[i.id].opt_itemType !== 'contribution' &&
                          //     gameElements[i.id].opt_itemType !== 'realworld' &&
                          //     gameElements[i.id].opt_itemType !== 'prizepack'
                          // )
                          .reduce((partialSum, a) => partialSum + a.count, 0)
                        :
                        '0'
                    }
                  </button>
                }
                {
                  (manager && gameData.access.includes('secretCodes')) &&
                  <button className='g-button text-only chart-button' onClick={() => navigate(`${player.path}/mysecretcodes`)}>
                    {player.codes ? Object.values(player.codes).reduce((acc, cur) => acc + cur.count, 0) : '0'}
                  </button>
                }
                {
                  (manager && gameData.access.includes('challenges')) &&
                  <button className='g-button text-only chart-button' onClick={() => navigate(`${player.path}/mychallenges`)}>
                    {player.challenges ? Object.values(player.challenges).reduce((acc, cur) => acc + cur.count, 0) : '0'}
                  </button>
                }
                {
                  (manager && gameData.access.includes('quests')) &&
                  <button className='g-button text-only chart-button'>
                    {(player.quests) ? Object.keys(player.quests).length : 0}
                  </button>
                } */}
              </div>
            )
          })
        }
      </div>

    </div>
  )
}

export default PlayerListDesktop